<template>
    <div>
        <div class="items">
            <div class="item card-white""> <!-- :class="{ 'margin-200-top': status.complete } -->

                <div class="card" v-if="!status.complete">
                  <eyebrow-icon v-if="true" v-bind:eyebrowicon="{'icon':'star-outline', 'color':'black'}" v-bind:align="'center'"></eyebrow-icon>
                  <h4>Share your feedback on AirMini</h4>
                </div>

                <form id="ContactForm" ref="contact_form" class="contact-form" action="javascript:" v-on:submit.prevent="submit">

                    <div v-if="!status.complete">

                      <!-- stars rating -->
                      <starRating></starRating>

                        <div class="group">
                          <label for="userLength">How long have you been using your AirMini?</label>
                          <select class="validation selectOptGroup"
                                  id="userLength"
                                  v-bind:class="{ '-invalid': validation.userLength }"
                                  v-model="fields.userLength"
                                  @change="validation.userLength = null">
                            <option selected disabled value="">Select from the following options...</option>
                            <option value="Less than 3 months">Less than 3 months</option>
                            <option value="3 – 5 months ">3 – 5 months </option>
                            <option value="6 months – 1 year">6 months – 1 year</option>
                            <option value="1 – 2 years">1 – 2 years</option>
                          </select>
                          <div class="error-message" v-for="message in validation.userLength">{{ message }}</div>
                        </div>


                        <div class="group">
                          <label for="airMiniAccessories">Which {{ this.acf.model }} accessory did you purchase?</label>

                          <input type="checkbox" value="AirMini filters" id="airmini_filters" name="airmini_filters" v-model="fields.airMiniAccessories" @change="validation.airMiniAccessories = null">
                          <label class="check vertical-size" for="airmini_filters">AirMini filters</label>

                          <input type="checkbox" value="Mount system" id="mount_system" name="mount_system" v-model="fields.airMiniAccessories" @change="validation.airMiniAccessories = null">
                          <label class="check vertical-size" for="mount_system">Mount system</label>

                          <input type="checkbox" value="HumidX/ HumidX Plus" id="humidx_humidx_plus" name="humidx_humidx_plus" v-model="fields.airMiniAccessories" @change="validation.airMiniAccessories = null">
                          <label class="check vertical-size" for="humidx_humidx_plus">HumidX/ HumidX Plus</label>

                          <input type="checkbox" value="AC adapter" id="ac_adapter" name="ac_adapter" v-model="fields.airMiniAccessories" @change="validation.airMiniAccessories = null">
                          <label class="check vertical-size" for="ac_adapter">AC adapter</label>

                          <input type="checkbox" value="Premium travel bag" id="premium_travel_bag" name="premium_travel_bag" v-model="fields.airMiniAccessories" @change="validation.airMiniAccessories = null">
                          <label class="check vertical-size" for="premium_travel_bag">Premium travel bag</label>

                          <input type="checkbox" value="DC/DC converters" id="dcdc_converter" name="dcdc_converter" v-model="fields.airMiniAccessories" @change="validation.airMiniAccessories = null">
                          <label class="check vertical-size" for="dcdc_converter">DC/DC converters</label>

                          <input type="checkbox" value="Hard travel case" id="hard_travel_case" name="hard_travel_case" v-model="fields.airMiniAccessories" @change="validation.airMiniAccessories = null">
                          <label class="check vertical-size" for="hard_travel_case">Hard travel case</label>

                          <input type="checkbox" value="Did not purchase" id="did_not_purchase_accessories" name="did_not_purchase_accessories" v-model="fields.airMiniAccessories" @change="validation.airMiniAccessories = null">
                          <label class="check vertical-size" for="did_not_purchase_accessories">Did not purchase</label>

                          <div class="error-message only-text" v-for="message in validation.airMiniAccessories">{{ message }}</div>
                        </div>

                        <h5>Please leave your review</h5>
                       <div class="card-container">
                          <div class="card-title" >
                            <img src="@/assets/images/info-solid.svg" class="info-svg" />
                            <span class="s-title">When writing a review please refrain from: </span>
                          </div>
                          <div class="card-message">
                            <div class="item-message">1. Directly naming other companies or products good or bad.</div>
                            <div class="item-message">2. Using inappropriate or profane language.</div>
                            <div class="item-message">3. Disclosing personally identifiable information.</div>
                          </div>
                        </div><br>
                        
                        <div class="group">
                          <label for="recommendProduct">Would you recommend this machine to other CPAP users?</label>

                         
                          <label class="check container-radio" for="yes">Yes 
                            <input type="radio" id="yes" name="recommendProduct" v-model="fields.recommendProduct" value="yes" @change="validation.recommendProduct = null">
                            <span class="checkmark"></span>
                          </label>
                          <label class="check container-radio" for="no">No 
                            <input type="radio" id="no" name="recommendProduct" v-model="fields.recommendProduct" value="no" @change="validation.recommendProduct = null">
                            <span class="checkmark"></span>
                          </label>

                          <div class="error-message only-text" v-for="message in validation.recommendProduct">{{ message }}</div>
                        </div>

                        <div class="group">
                          <label for="reviewTitle">Review title</label>
                          <input type="text"
                                 class="validation"
                                 id="reviewTitle"
                                 placeholder="Add a title (max 35 characters)"
                                 v-bind:class="{ '-invalid': validation.reviewTitle }"
                                 v-model="fields.reviewTitle"
                                 v-on:keyup="validation.reviewTitle = null" maxlength="35">
                          <div class="error-message" v-for="message in validation.reviewTitle">{{ message }}</div>
                        </div>

                        <div class="group">
                          <label for="reviewDescription">Review</label>
                          <textarea class="validation"
                                id="reviewDescription"
                                 placeholder="Please write your review here (min 50 characters)"
                                 v-bind:class="{ '-invalid': validation.reviewDescription }"
                                 v-model="fields.reviewDescription"
                                 v-on:keyup="validation.reviewDescription = null" ></textarea>
                          <div class="error-message" v-for="message in validation.reviewDescription">{{ message }}</div>
                        </div>

                        <!-- firstname -->
                        <firstname></firstname>

                        <!-- lastname -->
                        <lastname></lastname>

                        <!-- email and phone -->
                       <email></email>

                        <!-- select: country -->
                        <country></country>

                        <!-- select: satate -->
                        <component :is="states[fields.country]"></component>

                        <!-- checkbox: feedbackConcent -->
                        <feedbackConsent></feedbackConsent>

                        <!-- checkbox: marketing_oncent -->
                        <marketingConsent></marketingConsent>

                        <!-- submit, validation and confirmation -->
                        <submit-confirmation></submit-confirmation>

                        <input type="hidden" name="travelDeviceModel" v-model="fields.travelDeviceModel">

                    </div>
                </form>
                <thankyou-message v-if="status.complete"></thankyou-message>
            </div>
        </div>
    </div>

</template>
<style lang="scss" scoped>
@media (max-width: 767.98px) {
  label.check.vertical-size {
    width: 100% !important;
  }
}
</style>
<script>
import mixin from "./mixin.js";

let fillable = {
  starRating: "",
  userLength: "",
  airMiniAccessories: [],
  recommendProduct: "",
  reviewTitle: "",
  reviewDescription: "",
  firstname: "",
  lastname: "",
  email: "",
  country: "",
  state: "",
  feedbackConsent: "",
  marketing_consent: true,
  referrer: window.location.pathname,
  b2c: "yes",
  b2b: "no",
  yes_Rating: true,
  no_Rating: false,
  travelDeviceModel: "",
  timeOnMachineDatestamp: "",
  marketingConsentDate: new Date().toISOString(),
};

export default {
  data() {
    return {
      form: {
        name: "", // form name
        origin: "", // form origin ( page )
      },
      status: {
        idle: null,
        step: [],
        last_step: [],
        errors: false,
        complete: false,
      },
      response: {
        type: "", // validation or confirmation
        message: "", // response
      },
      holdingValue: {},
      userLengthRequired: true,
      sendTimeOnMachineDatestamp: false,
      fields: { ...fillable },
      validation: {},
      states: {
        "United States": "stateUS",
        Canada: "stateCA",
      },
    };
  },
  mixins: [mixin],
};
</script>
